<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 mb-2 globalborder-btm-header px-3">
        <span class="col-auto">
          <h2 class="mb-0">Order # {{ saleOrderId }}</h2></span
        >

        <span class="d-flex gap-2 customizefilter-btn">
          <span class="cross-border" (click)="redirectToSummary()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>
    </p-card>
  </div>
</div>

<div class="col-12 adduser-container-hgt px-3">
  <form [formGroup]="saleOrderItemLine">
    <div class="orders-srcvendor pb-4 mb-2">
      <div class="row collapseable" [ngClass]="{ active: collapseStatus }">
        <div class="col-4">
          <div
            class="gray-bg-rounded"
            [hidden]="orderType === 'inventory-sales'">
            <jni-inventory-order-line-vendor
              #vendor
              [parent]="saleOrderItemLine"
              (vendorAccountEvent)="getVendorAccountField()"
              (vendorObjectEvent)="getVendorObject($event)"
              [formErrors]="formErrors"
              (validationErrorEvent)="logValidationErrors()"
              (poAssignmentEvent)="openSideBarForPoAssignment($event)"
              [poAssignment]="poAssignment"
              [saleOrderLine]="saleOrderLine"
              [vendorAccountNumber]="vendorId"
              [isFromCdi]="isFromCdi"
              [createdBy]="createdBy"
              [createdDate]="createdDate"
              [modifiedBy]="modifiedBy"
              [modifiedDate]="modifiedDate"
              [isEdit]="isEdit"
              (currencyFromVendorEvent)="currencyFromVendorEvent($event)"
              [orderType]="orderType"
              [collapseStatus]="
                collapseStatus
              "></jni-inventory-order-line-vendor>
          </div>
        </div>
        <div class="col-4">
          <div class="gray-bg-rounded">
            <jni-inventory-order-line-ship-to
              #shipTo
              [parent]="saleOrderItemLine"
              [deliveryAddress]="deliveryAddress"
              [countryRegionList]="countryRegionList"
              [vendroAddressBookObject]="vendroAddressBookObject"
              [addressObject]="addressObject"
              [headerObject]="headerObject"
              [customerList]="customerLists"
              [customerBillToObject]="customerBillToObject"
              [showAddress]="showAddress"
              [formErrors]="formErrors"
              [clientShipToAddressDisabled]="clientShipToAddressDisabled"
              [vendorNameShipToAddressDisabled]="
                vendorNameShipToAddressDisabled
              "
              [orderType]="orderType"
              (validationErrorEvent)="logValidationErrors()"
              [isEditFromCdi]="isFromCdi"
              (isMelissaValidationIgnore)="
                isMelissaValidationIgnoreEvent($event)
              "
              (isMelissaAddressValidated)="
                isMelissaAddressValidatedEvent($event)
              "
              [selectedServiceLine]="selectedServiceLine"
              [collapseStatus]="
                collapseStatus
              "></jni-inventory-order-line-ship-to>
          </div>
        </div>
        <div class="col-4">
          <div class="gray-bg-rounded">
            <jni-inventory-order-line-item-details
              #details
              [parent]="saleOrderItemLine"
              [shippingProductsList]="shippingProductsList"
              [customerId]="customerId"
              [headerShipDate]="shipDate"
              [headerInhandDate]="inHandDate"
              [formErrors]="formErrors"
              (validationErrorEvent)="logValidationErrors()"
              [orderType]="orderType"></jni-inventory-order-line-item-details>
            <!-- <div class="d-flex justify-content-between">
            <div class="collapse-section border-0 mb-minus-2 position-absolute">
              <a
                class="btn-collapse"
                (click)="onToggle()"
                [ngClass]="{ active: collapseStatus }"
                >{{ collapseHeading }} <i class="icon-angle-double"></i
              ></a>
            </div>
          </div> -->
            <div class="d-flex justify-content-end mt-minus">
              <div class="border-0 collapse-section d-flex">
                <a
                  class="btn-collapse"
                  (click)="onToggle()"
                  [ngClass]="{ active: collapseStatus }"
                  >{{ collapseHeading }} <i class="icon-angle-double"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col" *ngIf="showHistory">
      <div class="row">
        <div class="col">
          <div
            class="mb-2 text-right"
            style="text-align: right; color: #0085fe; font-size: 0.875rem">
            Copied from
            <a (click)="redirectToCopiedFrom()" class="link bold mx-2"
              >{{ setCopiedFromInfo() }}
            </a>
            {{ saleOrderLineHistory?.createdDate | date: "MM-dd-yyyy" }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="gray-bg-rounded">
          <jni-inventory-order-line-detail
            #lineDetail
            [parent]="saleOrderItemLine"
            [showCommissionsFields]="showCommissionsFields"
            [currencyList]="currencyList"
            [releasedProductsList]="releasedProductsList"
            [sellCurrencyStatus]="sellCurrencyStatus"
            [formErrors]="formErrors"
            (validationErrorEvent)="logValidationErrors()"
            [netFieldStatus]="netFieldStatus"
            [sellRateValueWithIconStatus]="sellRateValueWithIconStatus"
            [userBlockedFromEdit]="userBlockedFromEdit"
            [orderLineNumber]="orderLineNumber"
            [salesOrderLine]="salesOrderLine"
            [isFromCdi]="isFromCdi"
            [orderType]="orderType"
            [customerAccountNumber]="customerId"
            [releasedProductsVariantsList]="releasedProductsVariantsList"
            [customerFinancialDimension]="customerFinancialDimension"
            [selectedItemNumber]="
              selectedItemNumber
            "></jni-inventory-order-line-detail>
        </div>
      </div>
      <div class="col-6">
        <div class="gray-bg-rounded" formGroupName="lines">
          <div class="row">
            <div class="col">
              <div
                class="d-flex align-items-center justify-content-between mb-2">
                <label class="form-label">Description</label>

                <a
                  (click)="showPositionDialogDescription('bottomright')"
                  class="link bold fontbold text-underline"
                  >Stock Phrase</a
                >
              </div>
              <div class="form-group has-float-label">
                <textarea
                  pInputText
                  rows="10"
                  jniAutoCompleteBlocker
                  id="descriptionid"
                  #scrollBottom
                  class="form-control b-height"
                  formControlName="lineDescriptionD365"
                  (focusout)="
                    applylineDescriptionLengthValidation($event)
                  "></textarea>
              </div>
            </div>
            <div class="col" [hidden]="orderType === 'inventory-sales'">
              <div
                class="d-flex align-items-center justify-content-between mb-2">
                <label class="form-label">Factory notes</label>
                <a
                  (click)="showPositionDialogFactory('bottomright')"
                  class="link bold fontbold text-underline"
                  >Stock Phrase</a
                >
              </div>
              <div class="form-group has-float-label">
                <textarea
                  pInputText
                  rows="10"
                  jniAutoCompleteBlocker
                  #scrollBottom
                  class="form-control b-height"
                  formControlName="factoryNotes"
                  (focusout)="
                    applyfactoryNotesLengthValidation($event)
                  "></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex py-3 has-sticky justify-content-between has-fixed">
      <div class="d-flex gap-2">
        <p-button
          label="Copy Header"
          title="Create new line with same Vendor, Ship To and Header Details"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Copy Header')"
          [hidden]="orderType === 'inventory-purchase'" />

        <p-button
          label="Copy Line"
          title="Create new line as Copy of current line"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Copy Line')" />

        <p-button
          label="Add Setup"
          title="Create new Set-Up Charge line"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Add Setup')"
          [hidden]="orderType === 'inventory-sales'" />

        <p-button
          label="Add Misc"
          title="Create new Misc Charge line"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Misc')"
          [hidden]="orderType !== 'inventory-sales'" />

        <!-- <button
          type="button"
          title="Create new line with same Vendor, Ship To and Header Details"
          class="btn btn-primary me-3"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Copy Header')"
          [hidden]="orderType === 'inventory-purchase'">
          Copy Header
        </button>
        <button
          type="button"
          title="Create new line as Copy of current line"
          class="btn btn-primary me-3"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Copy Line')">
          Copy Line
        </button> -->
        <!-- <button
          type="button"
          title="Create new Set-Up Charge line"
          class="btn btn-primary"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Add Setup')"
          [hidden]="orderType === 'inventory-sales'">
          Add Setup
        </button> -->
        <!-- <button
          type="button"
          title="Create new Misc Charge line"
          class="btn btn-primary"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          "
          (click)="next('Misc')"
          [hidden]="orderType !== 'inventory-sales'">
          Add Misc
        </button> -->
      </div>
      <div class="d-flex gap-2">
        <p-button
          label="Cancel"
          (click)="redirectToSummary()"
          variant="outlined"
          severity="secondary" />

        <p-button
          label="Done"
          (click)="onSubmit()"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          " />

        <p-button
          label=" Add Line"
          (click)="next('Add Line')"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          " />

        <!-- <button
          type="button"
          class="btn btn-secondary me-3"
          (click)="redirectToSummary()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary me-3"
          (click)="onSubmit()"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          ">
          Done
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="next('Add Line')"
          *ngIf="
            (lineStatusD365.toLowerCase() !== 'invoiced' &&
              userBlockedFromEdit &&
              !isLineProposalExist) ||
            isPartiallyInvoicedOrderLines
          ">
          Add Line
        </button> -->
      </div>
    </div>
  </form>
</div>

<jni-stock-phrases
  #stockPhraseDescription
  [flag]="'description'"
  [displayPosition]="displayPositionDescription"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogDescription()"
  (notesAndFactEvent)="getDescription($event)"></jni-stock-phrases>

<jni-stock-phrases
  #stockPhraseFactory
  [flag]="'factory'"
  [displayPosition]="displayPositionFactory"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogFactory()"
  (notesAndFactEvent)="getFactory($event)"></jni-stock-phrases>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="copiedFromSalesOrderId"></jni-order-summary>
  </div>
</jni-modal-stacker>

<!-- <jni-modal-stacker
  *ngIf="inventoryServiceLinesDisplayModal"
  [displayModal]="inventoryServiceLinesDisplayModal"
  (closeEvent)="closeModalFromInventoryServiceLines()"
  class="modal-header-sticky"
> -->
<!-- <div class="panelBody"> -->
<!-- <jni-inventory-purchase-lines
      [purchaseOrderNumber]="samplePONumber"
      [fromStacker]="true"
      (closeEvent)="closeModalFromSamplePOSummary()"
    ></jni-inventory-purchase-lines> -->
<!-- <jni-inventory-purchase-line-services-form
      [parent]="linesGroupForm"
      [saleOrderIdFromModal]="purchaseOrderNumber"
      [lineGroup]="selectedLineGroup"
      [site]="purchaseOrderHeader?.siteD365 || ''"
      [warehouse]="purchaseOrderHeader?.warehouseD365 || ''"
      [saleOrderModalStatus]="true"
      (closeEvent)="closeModalFromInventoryServiceLines()"
    ></jni-inventory-purchase-line-services-form>
  </div>
</jni-modal-stacker> -->
